<template>
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M27.36 3.57H2.64A2.64 2.64 0 0 0 0 6.21V23.8a2.64 2.64 0 0 0 2.64 2.64h24.72A2.64 2.64 0 0 0 30 23.79V6.2a2.64 2.64 0 0 0-2.64-2.64ZM27 5.33 15.06 17.28 3 5.33H27ZM1.76 23.43V6.57l8.46 8.39-8.46 8.47ZM3 24.67l8.47-8.47 2.97 2.94c.34.34.9.34 1.24 0l2.9-2.9L27 24.67H3Zm25.24-1.25L19.82 15l8.42-8.43v16.86Z" fill="currentColor" />
  </svg>
</template>
